import angular from 'angular';
import "babel-polyfill";

import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';
import uiMask from 'angular-ui-mask';

import {CommonModule} from './common/app.common.module';
import {DirectivesModule} from './directives/app.directives.module';
import {FiltersModule} from './filters/app.filters.module';
import {ServicesModule} from './services/services.module';
import {PagesModule} from './pages/pages.module';

import {AppComponent} from './app.component';

export const AppModule = angular
    .module('mmsApp', [
        uiRouter,
        uiBootstrap,
        uiMask,

        CommonModule,
        DirectivesModule,
        FiltersModule,
        ServicesModule,
        PagesModule,
    ])
    .config(($locationProvider) => {
        'ngInject';
        $locationProvider.html5Mode(true);
        // $locationProvider.hashPrefix('');
    })
    .run(($rootScope, $timeout) => {
        'ngInject';
        $timeout(() => {
            $rootScope.$pageFinishedLoading = true;
        });
    })
    // .run($trace => $trace.enable(1))
    .component(AppComponent.name, AppComponent.component)
    .name;



// WEBPACK FOOTER //
// ./src/app/app.module.js